module.exports = __webpack_public_path__ + "static/img/5.ac36824.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/5.png
// module id = TJiN
// module chunks = 0